import { StatusChip } from '@/components/molecules/StatusChip';
import type { EstimateStatus } from '@/types/estimate';

interface EstimateStatusBadgeProps {
  status: EstimateStatus;
  className?: string;
}

export function EstimateStatusBadge({ status, className }: EstimateStatusBadgeProps) {
  return <StatusChip status={status} className={className} />;
}
